import "./product-description-tooltip.scss"

import React from "react"

import IcoProductInfoTooltip from "assets/images/ico-product-info-tooltip.svg"

const ProductTooltip = ({ type }) => {
  return (
    <div className="product-description-tooltip">
      <button>
        <img src={IcoProductInfoTooltip} alt="" />
      </button>
      <div className="product-description-tooltip__wrapper">
        <div className="product-description-tooltip__inner">
          <p>
            {type === "N"
              ? "N - Laptop fabrycznie nowy"
              : type === "A+"
              ? "A+ - Stan niemal idealny - jak nowy. Niewidoczne ślady użytkowania."
              : type === "P"
              ? "Powystawowy - laptop pochodzi z nadwyżek magazynowych producenta."
              : type === "A"
              ? "A - Bardzo dobry stan. Minimalne, delikatne ślady użytkowania – np. drobne ryski lub przetarcia."
              : type === "A-"
              ? "A- - Dobry stan. Widoczne ślady użytkowania – ryski, lekkie przetarcia lub punktowe przebarwienia."
              : type === "A-*"
              ? "A-* -Gwiazdka przy opisie klasy oznacza minimalne ślady na matrycy (duszki), które nie przeszkadzają w codziennym użytkowaniu."
              : type === "B"
              ? "B - Stan mocno używany. Liczne i/lub głębokie rysy oraz drobne pęknięcia obudowy. Sprzęt technicznie sprawny, ale znacznie zużyty wizualnie."
              : type === "B+"
              ? "B+ - Stan akceptowalny. Wyraźniejsze zużycie – większe rysy i otarcia. Bez wpływu na działanie."
              : type === "C"
              ? "C - Stan mocno używany. Pęknięcia obudowy, rysy na matrycy. Sprzęt technicznie sprawny, jednak posiada defekty / ubytki obudowy."
              : ""}
          </p>
        </div>
      </div>
    </div>
  )
}

export default ProductTooltip
